import services from "@/services/reports";
import { Reports } from "@inctec/elearning-ui-client";
import coursesService from "@/services/courses";
import {
  stateInitial,
  stateLoading,
  stateLoaded,
  stateError,
} from "./loadingStates";

export default {
  state: {
    pickedAccountId: null,
    pickedCourse: null,
    courses: [],
    accountOverview: {},
    courseOverview: {},
    courseDetails: {},
    assignmentReport: [],
    assignmentReportLoadingState: stateInitial,
  },
  mutations: {
    resetReportsState(state) {
      state.pickedAccountId = null;
      state.pickedCourse = null;
      state.courses = [];
      state.accountOverview = {};
      state.courseOverview = {};
      state.courseDetails = {};
      state.assignmentReport = [];
      state.assignmentReportLoadingState = stateInitial;
    },
    assignmentReportLoadingState(state, payload) {
      state.assignmentReport = payload;
      state.assignmentReportLoadingState = stateLoaded;
    },
    assignmentReportLoading(state, payload) {
      state.assignmentReportLoadingState = stateLoading;
    },
    assignmentReportError(state, payload) {
      state.assignmentReportError = { ...stateError, error: payload };
    },
    setAccountId(state, payload) {
      if (payload || payload === 0) {
        state.pickedAccountId = +payload;
      }
    },
    setCourseId(state, payload) {
      if (payload || payload === 0) {
        state.pickedCourse = payload;
      }
    },
    setAccountOverview(state, payload) {
      if (payload || payload === 0) {
        state.accountOverview = payload;
      }
    },
    setCourseOverview(state, payload) {
      if (payload || payload === 0) {
        state.courseOverview = payload;
      }
    },
    setCourseDetails(state, payload) {
      if (payload || payload === 0) {
        state.courseDetails = payload;
      }
    },
  },
  actions: {
    loadAssignmentReports({ commit }, { id }) {
      commit("assignmentReportLoading");
      services.GET_ASSIGNMENT_REPORT(id).then(
        (response) => {
          commit("assignmentReportLoadingState", response);
        },
        (error) => {
          commit("assignmentReportError", error);
        },
      );
    },
  },
  getters: {
    assignmentsReport: (state) => state.assignmentReport,
    assignmentsReportLoading: (state) =>
      state.assignmentReportLoadingState.loading,
    assignmentsReportLoaded: (state) =>
      state.assignmentReportLoadingState.loaded,
    assignmentsReportError: (state) => state.assignmentReportLoadingState.error,
    getAssignmentsReportLoadingState: (state) =>
      state.assignmentReportLoadingState,
    getAccountOverview: (state) => state.accountOverview,
    getReportPickedAccount: (state) => state.pickedAccountId,
    getCourseDetails: (state) => state.courseDetails,
    getCourseOverview: (state) => state.courseOverview,
  },
};
